<!--  -->
<template>
  <div class="ProductDetails">
    <h1>
      <router-link to="/">{{ shouye }}</router-link>
      >
      <router-link to="/Product">{{ chanpin }}</router-link>
    </h1>
    <div class="Product_box">
      <div class="Product_show">
        <div class="Product_two">
          <img class="imgControl" :src="show_photo" />
        </div>
        <ul class="Product_one">
          <li
            v-for="(item, index) in product_photo"
            :key="index"
            @click="ChangeShow(item.src)"
          >
            <img class="imgControl" :src="item.src" />
          </li>
        </ul>
      </div>
      <div class="Product_three">
        <h1>
          {{ product_title }}
          <span v-if="product_title2">({{ product_title2 }})</span>
        </h1>
        <p>{{ start_price }}-{{ end_price }}/{{ Piece }}</p>
        <div class="MOQ">
          <span>{{ MOQ }}:</span>
          <span>({{ numb }} {{ Piece }})</span>
        </div>
        <div class="shelf_life">
          <span>{{ shelf_life }}:</span>
          <span>{{ time }} {{ time_units }}</span>
        </div>

        <ul class="renzheng">
          <li v-for="item in renzhengList" :key="item.id">
            <img :src="item.src" />
            <span>{{ item.msg }}</span>
          </li>
        </ul>

        <div class="learn">
          <router-link to="/ContactUs">{{ lookmore }}</router-link>
        </div>
      </div>
    </div>

    <div class="list">
      <ul>
        <li
          v-for="(item, index) in title_list"
          :key="index"
          :class="{ Liactive: isActive == index }"
        >
          <span
            ref="spans"
            @click="jump(index)"
            :class="{ active: isActive == index }"
          >
            {{ item.title }}
          </span>
        </li>
      </ul>
    </div>
    <div class="result" @scroll="onScroll">
      <div class="scroll-item">
        <h1>{{ dzlc }}</h1>
        <div class="Details" v-html="msg1"></div>
      </div>
      <div class="scroll-item">
        <h1>{{ bzfs }}</h1>
        <div class="Details" v-html="msg2"></div>
      </div>
      <div class="scroll-item">
        <h1>{{ gf }}</h1>
        <div class="Details" v-html="msg3"></div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 面包屑
      shouye: "Home",
      chanpin: "Product",

      //详情产品展示图
      product_photo: [],
      show_photo: "",

      //详情产品信息
      product_title: "",
      product_title2: "",
      start_price: "",
      end_price: "",
      Piece: "",
      MOQ: "MOQ",
      numb: "",
      shelf_life: "",
      time: "",
      time_units: "",

      renzhengList: [
        {
          id: "1",
          src: require("../../assets/product/renzheng1.png"),
          msg: "",
        },
        {
          id: "2",
          src: require("../../assets/product/renzheng2.png"),
          msg: "",
        },
        {
          id: "3",
          src: require("../../assets/product/renzheng3.png"),
          msg: "",
        },
        {
          id: "4",
          src: require("../../assets/product/renzheng4.png"),
          msg: "",
        },
      ],

      lookmore: "",

      isActive: 0,

      activeStep: 0,
      title_list: [
        {
          title: "",
        },
        {
          title: "",
        },
        {
          title: "",
        },
      ],
      dzlc: "",
      bzfs: "",
      gf: "",
      msg1: "",
      msg2: "",
      msg3: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    ChangeShow(photo) {
      this.show_photo = photo;
    },

    jump(index) {
      this.isActive = index;
      var items = document.querySelectorAll(".scroll-item");
      for (var i = 0; i < items.length; i++) {
        if (index === i) {
          items[i].scrollIntoView({
            block: "start", //默认跳转到顶部
            behavior: "smooth", //滚动的速度
          });
        }
      }
    },
    onScroll(e) {
      let scrollItems = document.querySelectorAll(".scroll-item");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge =
          e.target.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop;
        if (judge) {
          this.activeStep = i;
          break;
        }
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var that = this;
    var v = parseUrl();
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "get_article",
        article_id: v.id,
        xiaji: 1,
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          if (obj.data) {
            if (obj.data.pic_lists) {
              $.each(obj.data.pic_lists, function (i, k) {
                that.product_photo.push({
                  src: k,
                });
                if (i == 0) {
                  that.show_photo = k;
                }
              });
              that.product_title = obj.data.title;
              that.product_title2 = obj.data.description;
              var linshi = obj.data.sign.split("/");
              linshi = linshi[0].split("-");
              that.start_price = linshi[0];
              that.end_price = linshi[1];
              var linshi = obj.data.link_url.split("@");
              that.numb = linshi[0];
              that.time = linshi[1];
              // 更新产品下的流程和包装
              that.msg1 = obj.data.xiaji[0].msg;
              that.msg2 = obj.data.xiaji[1].msg;
              that.msg3 = obj.data.msg;
            }
          }
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
    // 获取界面翻译项
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "get",
      datatype: "json",
      data: {
        act: "get_fanyi",
      },
      success: function (ret) {
        var obj = JSON.parse(ret); //json数据转为数组
        if (obj.code == "0000") {
          that.Piece = obj.data["mj"];
          that.lookmore = obj.data["gengduo"];
          that.shelf_life = obj.data["bzq"];
          that.renzhengList[0].msg = obj.data["gjmsg"];
          that.renzhengList[1].msg = obj.data["fwmsg"];
          that.renzhengList[2].msg = obj.data["bzmsg"];
          that.renzhengList[3].msg = obj.data["shmsg"];
          that.title_list[0].title = obj.data["dzlc"];
          that.dzlc = obj.data["dzlc"];
          that.title_list[1].title = obj.data["bzfs"];
          that.bzfs = obj.data["bzfs"];
          that.title_list[2].title = obj.data["gf"];
          that.gf = obj.data["gf"];
        }
      },
      error: function (err) {
        console.log("ajax错误");
      },
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};

function parseUrl() {
  var url = location.href;
  var i = url.indexOf("?");
  if (i == -1) return;
  var querystr = url.substr(i + 1);
  var arr1 = querystr.split("&");
  var arr2 = new Object();
  for (i in arr1) {
    var ta = arr1[i].split("=");
    arr2[ta[0]] = ta[1];
  }
  return arr2;
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.ProductDetails {
  width: 100%;
  padding: 55px 9.25rem 110px;
  h1 {
    font-size: 1.2rem;
    font-weight: bold;
    color: #969696;
  }
  .Product_box {
    width: 100%;
    margin-top: 50px;
    display: flex;
    .Product_show {
      display: flex;
      flex-direction: row-reverse;
      .Product_one {
        width: 103px;
        display: flex;
        flex-direction: column;
        li {
          cursor: pointer;
        }
        li:not(:first-child) {
          margin-top: 18px;
        }
      }
      .Product_two {
        width: 595px;
        height: 100%;
        margin-left: 30px;
      }
    }
    .Product_three {
      margin-left: 30px;
      h1 {
        font-size: 1.5rem;
        font-weight: 900;
        color: #39404a;
        span {
          font-size: 1.2rem;
          font-weight: 400;
          color: #2d2d2d;
        }
      }
      p {
        margin-top: 35px;
        font-size: 1.2rem;
        font-weight: bold;
        color: #fbc342;
      }
      .MOQ {
        margin-top: 35px;
        font-size: 1rem;
        font-weight: bold;
        span:nth-child(1) {
          color: #2d2d2d;
          font-weight: 900;
        }
        span:nth-child(2) {
          margin-left: 60px;
          color: #2d2d2d;
        }
      }
      .shelf_life {
        margin-top: 20px;
        font-size: 0.9rem;
        font-weight: bold;
        span:nth-child(1) {
          color: #2d2d2d;
          font-weight: 900;
        }
        span:nth-child(2) {
          margin-left: 35px;
          color: #2d2d2d;
        }
      }
    }

    .renzheng {
      width: 90%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 15px;
      li {
        margin-top: 20px;
        width: 46%;
        span {
          font-size: 0.8rem;
          font-weight: bold;
          color: #2d2d2d;
          margin-left: 15px;
        }
      }
    }

    .learn {
      margin-top: 90px;
      width: 192px;
      height: 60px;
      background: #fbc342;
      a {
        display: inline-block;
        width: 100%;
        text-align: center;
        font-size: 1rem;
        font-weight: 900;
        color: #ffffff;
        line-height: 60px;
      }
    }
  }
  .list {
    padding-top: 90px;
    ul {
      width: 100%;
      display: flex;
      .Liactive {
        background: #5fbb68;
        border-radius: 5px;
      }
      li {
        background: #efffd0;
        border-radius: 5px;
        margin: 0 5px;
        transition: 0.3s;
        cursor: pointer;
        span {
          display: inline-block;
          padding: 30px 35px;
          text-align: center;
          width: 100%;
          height: 100%;
          font-size: 30px;
          font-family: Arial;
          font-weight: 400;
          color: #5fbb68;
          transition: 0.3s;
        }
        .active {
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }
  .result {
    .scroll-item {
      margin-top: 60px;
      h1 {
        font-size: 30px;
        font-family: Arial;
        font-weight: bold;
        color: #2d2d2d;
        text-align: center;
      }
      .Details {
        margin-top: 20px;
      }

      .Details >>> img {
        max-width: 100%;
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  .ProductDetails {
    width: 100%;
    padding: 55px 2rem 110px;
  }
}
@media screen and (max-width: 1000px) {
  .ProductDetails {
    width: 100%;
    padding: 55px 1rem 110px;
  }
}
@media screen and (max-width: 900px) {
  .ProductDetails {
    .Product_box {
      flex-wrap: wrap;
      justify-content: space-between;
      .Product_show {
        flex-direction: column;
        .Product_one {
          display: flex;
          width: 100%;
          justify-content: space-between;
          flex-direction: row;
          li {
            width: 20%;
            margin: 10px 5px;
            img {
              width: 100%;
              height: auto;
            }
          }
          li:not(:first-child) {
            margin: 10px 5px;
            img {
              width: 100%;
              height: auto;
            }
          }
        }
        .Product_two {
          width: 100%;
          margin-left: 0;
        }
      }
      .Product_three {
        margin-left: 0;
        .renzheng {
          width: 100%;
        }
        .learn {
          margin-top: 40px;
        }
      }
    }
    .list {
      padding-top: 40px;
      ul {
        flex-direction: column;
        li {
          margin: 10px 0;
          span {
            padding: 15px 20px;
            font-size: 1.6rem;
          }
        }
      }
    }
    .result {
      .scroll-item {
        h1 {
          font-size: 1.6rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Product/ProductDetails.vue